/**
 * Video Overlay Handler
 * Handles click-to-play functionality for video thumbnails.
 * Uses postMessage to trigger play on the already-loaded iframe.
 */

export function videoOverlayInit(): void {
  const containers = document.querySelectorAll('[data-video-container]')

  containers.forEach((container) => {
    const overlay = container.querySelector('[data-video-overlay]')
    const iframeWrapper = container.querySelector<HTMLElement>('[data-video-iframe]')
    const iframe = iframeWrapper?.querySelector<HTMLIFrameElement>('iframe')

    if (!overlay || !iframeWrapper || !iframe) return

    // Add enablejsapi so we can send play commands via postMessage
    const src = iframe.getAttribute('src') || ''
    if (src && !src.includes('enablejsapi')) {
      const url = new URL(src)
      url.searchParams.set('enablejsapi', '1')
      iframe.setAttribute('src', url.toString())
    }

    overlay.addEventListener('click', () => {
      overlay.classList.add('is-hidden')

      // Tell the player to play via postMessage
      iframe.contentWindow?.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      )

      setTimeout(() => {
        overlay.remove()
      }, 300)
    })
  })
}
